export default __webpack_public_path__ + "static/media/supp_line_teeth.2c51f2c1.png";